module.exports = __webpack_public_path__ + "img/templates_empty_state.ac587529.svg";